import CreateGroup from '../../pages/Customer/CreateGroup';
import { CustomerController } from '../../controllers';
import constant from '../../utils/constant';
import React, { useState } from 'react';
import { observer } from 'mobx-react';
import * as yup from 'yup';

import { MimaToastUtil } from '../../components';

const CreateGroupContainer = ({ closeModal, goBack }) => {
	const [loading, setLoading] = useState(false);
	const validationSchema = () => {
		return yup.object({
			depts: yup.array(
				yup.object({
					name: yup.string().required('Group name is required'),
				})
			),
		});
	};

	const onSubmit = async payload => {
		setLoading(true);
		for (const key in payload) {
			if (payload[key] === '') {
				delete payload[key];
			}
		}
		const { status, errorMessage } = await CustomerController.createGroup(
			payload
		);
		if (status === constant.Success) {
			setLoading(false);
			MimaToastUtil.success({
				message: constant.Success,
			});
			return closeModal();
		}
		setLoading(false);
		return MimaToastUtil.error({
			message: errorMessage,
		});
	};

	return (
		<CreateGroup
			closeModal={closeModal}
			loading={loading}
			onSubmit={onSubmit}
			validationSchema={validationSchema}
			goBack={goBack}
		/>
	);
};

export default observer(CreateGroupContainer);
